import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import {
  Edit as EditIcon,
  Visibility as VisibilityIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import PermissionGuard from "../access-control/PermissionGuard";
import { RESOURCES, ACTIONS } from "../../hooks/usePermissions";

const TeachersTable = ({ teachers, onView, onEdit, onDelete }) => {
  return (
    <TableContainer component={Paper} elevation={0} sx={{ overflowX: "auto" }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 120 }}>Staff Number</TableCell>
            <TableCell sx={{ minWidth: 150 }}>Name</TableCell>
            <TableCell sx={{ minWidth: 80 }}>Gender</TableCell>
            <TableCell sx={{ minWidth: 120 }}>Phone</TableCell>
            <TableCell sx={{ minWidth: 200 }}>Qualification</TableCell>
            <TableCell sx={{ minWidth: 120 }}>Specialization</TableCell>
            <TableCell sx={{ minWidth: 120 }}>Employment Status</TableCell>
            <TableCell sx={{ minWidth: 100 }}>Status</TableCell>
            <TableCell sx={{ minWidth: 150, width: 150 }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {teachers.length > 0 ? (
            teachers.map((teacher) => (
              <TableRow key={teacher.id} hover>
                <TableCell>
                  <Typography variant="body2" color="primary" fontWeight="medium">
                    {teacher.staff_number}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight="medium">
                    {teacher.full_name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
                    {teacher.gender}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {teacher.phone_number || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary" noWrap>
                    {teacher.qualification || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary" noWrap>
                    {teacher.specialization || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip
                    label={teacher.employment_status}
                    color={teacher.employment_status === 'Active' ? 'success' : 'default'}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Chip
                    label={teacher.is_active ? "Active" : "Inactive"}
                    color={teacher.is_active ? "success" : "default"}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Box display="flex" gap={0.5}>
                    <Tooltip title="Teacher Details">
                      <IconButton size="small" color="info" onClick={() => onView(teacher)}>
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit Teacher">
                      <PermissionGuard resource={RESOURCES.USERS} action={ACTIONS.UPDATE}>
                        <IconButton size="small" color="primary" onClick={() => onEdit(teacher)}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </PermissionGuard>
                    </Tooltip>
                    <Tooltip title="Delete Teacher">
                      <PermissionGuard resource={RESOURCES.USERS} action={ACTIONS.DELETE}>
                        <IconButton size="small" color="error" onClick={() => onDelete(teacher.id)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </PermissionGuard>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  No teachers found
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TeachersTable;
